import React from "react";
import PropTypes from "prop-types";
import { classNames } from "../../utils";

const ICON_NAME = /** @type { const } */ ([
  "checked",
  "uncheck",
  "triangle-up",
  "triangle-down",
  "arrow-right",
  "arrow-left",
  "arrow-down",
  "arrow-up",
  "loading",
  "chevron-down",
  "close",
  "rectangle",
]);
/**
 *
 * @param {{
 * className: string,
 * name: import("../../..").ArrayToTuple<typeof ICON_NAME>
 * style: interface {}
 * }} props
 */
export default function Icon({ name, className, style = {}, ...props }) {
  return <span aria-hidden="true" {...props} style={{...style}}  className={classNames(`fs-${name}`, className, "fs-icon")}></span>;
}

Icon.propTypes = {
  name: PropTypes.oneOf(ICON_NAME),
  className: PropTypes.string,
};
